import styled from "styled-components";

import { ICON_HEIGHT } from "./_constants";

const IconTable = styled.img.attrs({
  src: "/assets/images/icon-table.png"
})`
  cursor: pointer;
  height: ${ICON_HEIGHT}px;
`;
IconTable.displayName = "IconTable";

export default IconTable;
